import { reducers, getState } from 'redux/core'
import request from 'sb-request'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { getCookieValue } from 'helpers'


const clear  = reducers.models.recommendations.clear
const setTag = reducers.models.recommendations.setTag

const update = ({ placement, tag }) => {
  setTag(tag)

  return fetch({ placement })
}

const fetch = ({ placement }) => {
  const { models: { me: { gender }, recommendations: { tag: { name } } } } = getState()

  const isRecommendationTagModalHidden = !getCookieValue(constants.modals.RecommendationTag)

  if (isRecommendationTagModalHidden) {
    return
  }

  return request.get(`rest/tag/${name}/recommendations`, {
    withErrorModal: false,
    query: {
      gender,
    },
    modifyResult: (items) => {
      if (placement === 'queue') {
        return items
      }

      return items.map(({ tradingItem: { id }, ...rest }) => ({
        ...rest,
        id,
      }))
    },
  })
    .then(
      (items) => {
        const { models: { modals: modalsList } } = getState()

        const hasModals           = Object.keys(modalsList).length
        const hasRecommendations  = items && items.length

        if (!hasRecommendations) {
          clear()
        }
        else if (!hasModals) {
          actions.misc.cookies.setSessionItem(constants.modals.RecommendationTag, true)
          reducers.models.recommendations.setItems(items)
          actions.models.modals.open(constants.modals.RecommendationTag, { placement })
        }
        else {
          console.log('Has modals', modalsList)
        }
      },
      () => {
        clear()
      })
}

export default {
  clear,
  setTag,
  update,
  fetch,
}
